import React from 'react'
import { Info } from 'lucide-react'

interface InfoTooltipProps {
  text: string
  className?: string
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, className = '' }) => (
  <span className={`relative group inline-flex items-center ${className}`}>
    <Info className="w-3 h-3 text-gray-400 cursor-help" />
    <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-lg bg-gray-800 px-3 py-2 text-xs text-white shadow-xl leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-50 whitespace-normal text-left">
      {text}
      <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
    </span>
  </span>
)

export default InfoTooltip
